import { useMemo } from "react";
import { makeQueryString } from "core/makeQueryString";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { CaseLabel } from "interfaces/case-label";

/** The object returned from the get case labels types hook  */
export type GetCaseLabelsResponse = {
  loading: boolean;
  error: boolean;
  caseLabels: CaseLabel[];
  refetch: () => void;
  count: number;
};

/** The response returned from the get case labels types fetch */
type FetchGetCaseLabelsResponse = {
  loading: boolean;
  error: boolean;
  response?: {
    results: CaseLabel[];
    count: number;
  };
  refetch: () => void;
};

export interface useGetCaseLabelsArgs {
  /** page the current page, defaults to the first page */
  page?: number;
  /** the size of the page, defaults to 10000 */
  pageSize?: number | string;
  visible?: number;
  ordering?: string | null;
}

export function useGetCaseLabels(
  optional: useGetCaseLabelsArgs = {}
): GetCaseLabelsResponse {
  const { page = 1, pageSize = 10000, visible = 1, ordering = null } = optional;
  const url = useMemo(
    () =>
      `case_labels` +
      makeQueryString({
        page,
        size: pageSize,
        visible: visible,
        ordering: ordering
      }),
    [page, pageSize, visible, ordering]
  );

  const {
    loading,
    error,
    response = { results: [], count: 0 },
    refetch
  }: FetchGetCaseLabelsResponse = useFetchGetV2(url);

  return {
    loading,
    error,
    caseLabels: response.results,
    refetch,
    count: response.count
  };
}
